import { FormControlLabel, Switch, useTheme } from '@mui/material';
import useIsMobile from 'hooks/useIsMobile';
import { useRecoilState, useRecoilValue } from 'recoil';
import { hasDashAccess, DashAccess } from 'types/user';

import { SGTooltip } from 'components/core';
import {
  newTVHiroState,
  userDashAccessState,
  userHiroV2EnabledState,
} from 'states';

export const HiroHeaderWidgetPostamble = () => {
  const userDashAccess = useRecoilValue(userDashAccessState);
  const theme = useTheme();
  const isMobile = useIsMobile();
  const [newTVHiro, setNewTVHiro] = useRecoilState(newTVHiroState);
  const userHiroV2Enabled = useRecoilValue(userHiroV2EnabledState);

  if (!hasDashAccess(userDashAccess, DashAccess.BETA) && !userHiroV2Enabled) {
    return null;
  }

  return (
    <SGTooltip title="Use the new version of HIRO which works on top of the Trading View charting library">
      <FormControlLabel
        sx={{
          marginLeft: '1.5ex',
          '& .MuiFormControlLabel-label': {
            color: theme.palette.primary.main,
            textAlign: 'center',
            fontSize: { xs: 12, md: 14 },
          },
        }}
        control={
          <Switch
            size={isMobile ? 'small' : 'medium'}
            sx={{
              '& .MuiSwitch-track': {
                opacity: 0.25,
                backgroundColor: theme.palette.success.main,
              },
              '&.Mui-checked .MuiSwitch-track': {
                opacity: 1,
              },
            }}
            color="success"
            checked={newTVHiro}
            onChange={() => setNewTVHiro(!newTVHiro)}
          />
        }
        label="HIRO Upgrade"
        labelPlacement={isMobile ? 'top' : 'start'}
      />
    </SGTooltip>
  );
};
